(function() {
  var bankDiscountNames = [
    'BANK25',
    'BANKMAX10000',
    'BANK TRANSFER - 2.5% OFF',
    'BANK TRANSFER - RS10,000 MAXIMUM'
  ];
  var resetKey = 'bank-discount-reset-v13';
  var routeRoot = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  function isBankDiscount(value) {
    return bankDiscountNames.indexOf(String(value || '').toUpperCase()) !== -1;
  }

  function cartHasBankDiscount(cart) {
    var applications = cart.cart_level_discount_applications || [];
    var codes = cart.discount_codes || [];

    return applications.some(function(application) {
      return isBankDiscount(application.title);
    }) || codes.some(function(discount) {
      return isBankDiscount(discount.code);
    });
  }

  function clearPersistedBankDiscount() {
    fetch(routeRoot + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to read the cart');
        return response.json();
      })
      .then(function(cart) {
        if (!cartHasBankDiscount(cart)) {
          sessionStorage.removeItem(resetKey);
          return null;
        }

        var lastReset = Number(sessionStorage.getItem(resetKey) || 0);
        if (Date.now() - lastReset < 10000) return null;

        sessionStorage.setItem(resetKey, String(Date.now()));
        return fetch(routeRoot + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
      })
      .then(function(response) {
        if (!response) return;
        if (!response.ok) throw new Error('Unable to clear the bank discount');
        window.location.reload();
      })
      .catch(function(error) {
        sessionStorage.removeItem(resetKey);
        console.error(error);
      });
  }

  clearPersistedBankDiscount();
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) clearPersistedBankDiscount();
  });
})();
